


























































































































































































































































































































import { defineComponent, reactive, toRefs, computed, watch, onMounted, onBeforeUnmount, ref } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import jsZip from "jszip";
import moment from 'moment';
import AlertArea from "../../components/AlertArea.vue";
import AnswerImageArea from "../../components/AnswerImageArea.vue";
import PreviewImageArea from "../../components/PreviewImageArea.vue";
import TextEditBox from "../../components/TextEditBox.vue";
import { Sheet, SheetField, PageItem, DirectionEnum, KaitouModeEnum, AnswerText, ParamSheetField, StudentSheetStatusEnum, PreviewImageTypeEnum } from "../../modules/digital_paper/AnswerInput"
import { SplitterComponent, PanesDirective, PaneDirective, ResizingEventArgs } from "@syncfusion/ej2-vue-layouts"
import VSwatches from 'vue-swatches'
import "vue-swatches/dist/vue-swatches.css"

export interface Data {
  initiarizedData: boolean
  student_sheet_id: string
  status: number
  times: number
  sheet: Sheet
  pageItems: PageItem[]
  base64QuestionImages: string[]
  base64CorrectImages: string[]
  DirectionEnum: Readonly<{Horizon: number; Vertical: number;}>
  direction: number
  selectedFieldIdx: number
  cutMargin: number
  mainAreaWidth: number
  mainAreaHeight: number
  horizonTopHeightPer: number
  horizonBottomHeightPer: number
  verticalLeftWidthPer: number
  verticalRightWidthPer: number
  separatorSize: number
  selectedAnswerPageIdx: number
  selectedQuestionPageIdx: number
  selectedCorrectPageIdx: number
  selectedAnswerText: AnswerText
  kaitouMode: number
  KaitouModeEnum: Readonly<{None: number; Text: number; FreeLine: number; StraightLine: number; Eraser: number; Delete: number;}>
  DigitalAnswerTypeEnum: Readonly<{Both: number; Draw: number; Text: number;}>
  fontSize: number
  lineHeight: number
  modeAreaLeft: number
  modeAreaTop: number
  modeAreaWidth: number
  pointerOffsetX: number
  pointerOffsetY: number
  isDragging: boolean
  before_student_sheet_id: number
  keyCode: string
  isShortcutKeyEnable: boolean
  pcHelpFields: any[]
  tabletHelpFields: any[]
  errors: string[]
  fromStudentSheetList: boolean
  remainingTime: number
  isRemainingTimeDisp: boolean
  timer: any
  isTimeOver: boolean
  isTimeOverAlertDisp: boolean
  isTextEnable: boolean
  isDrawEnable: boolean
  textColor: string
  drawColor: string
  thickness: number
  StudentSheetStatusEnum: Readonly<{Answering: number; SelfScoring: number; Completed: number;}>
  isScrolling: boolean
  scoringToolboxLeft: number
  scoringToolboxTop: number
  PreviewImageTypeEnum: Readonly<{None: number; Question: number; Correct: number;}>
  previewImageType: number
  isDispToggre: boolean
  isColorEnable: boolean
}

// @ts-ignore
export default defineComponent({
  components: {
    "alert-area": AlertArea,
    "answer-image-area": AnswerImageArea,
    "preview-image-area": PreviewImageArea,
    "text-edit-box": TextEditBox,
    "ejs-splitter" : SplitterComponent,
    "e-panes": PanesDirective,
    "e-pane": PaneDirective,
    "v-swatches": VSwatches,
  },
  setup(props, context){

    const horizonAnswerImageAreaRef = ref<InstanceType<typeof AnswerImageArea>>();
    const verticalAnswerImageAreaRef = ref<InstanceType<typeof AnswerImageArea>>();
    const horizonQuestionImageAreaRef = ref<InstanceType<typeof PreviewImageArea>>();
    const horizonCorrectImageAreaRef = ref<InstanceType<typeof PreviewImageArea>>();
    const verticalQuestionImageAreaRef = ref<InstanceType<typeof PreviewImageArea>>();
    const verticalCorrectImageAreaRef = ref<InstanceType<typeof PreviewImageArea>>();

    /******************************
     * data
     ******************************/
    const state = reactive<Data>({
      initiarizedData: false,
      student_sheet_id: null,
      status: null,
      times: null,
      sheet: null,
      pageItems: [],
      base64QuestionImages: [],
      base64CorrectImages: [],
      DirectionEnum: DirectionEnum,
      direction: DirectionEnum.Vertical,
      selectedFieldIdx: null,
      cutMargin: 0,
      mainAreaWidth: 0,
      mainAreaHeight: 0,
      horizonTopHeightPer: 0.5,
      horizonBottomHeightPer: 0.5,
      verticalLeftWidthPer: 0.5,
      verticalRightWidthPer: 0.5,
      separatorSize: 10,
      selectedAnswerPageIdx: 0,
      selectedQuestionPageIdx: 0,
      selectedCorrectPageIdx: 0,
      selectedAnswerText: null,
      kaitouMode: KaitouModeEnum.None,
      KaitouModeEnum: KaitouModeEnum,
      DigitalAnswerTypeEnum: Common.DigialAnswerTypeEnum,
      fontSize: 32,
      lineHeight: 0,
      modeAreaLeft: 0,
      modeAreaTop: 0,
      modeAreaWidth: 240,
      pointerOffsetX: 0,
      pointerOffsetY: 0,
      isDragging: false,
      before_student_sheet_id: null,
      keyCode: null,
      isShortcutKeyEnable: true,
      pcHelpFields: [
        { key: "Tキー + クリック", img: require("@/assets/images/keyboard_T.png"), description: "テキストボックスを出力" },
        { key: "テキスト選択中にBackSpaceキー", img: require("@/assets/images/keyboard_Backspace.png"), description: "テキストボックスを削除" },
        { key: "Dキー + マウス", img: require("@/assets/images/keyboard_D.png"), description: "自由線" },
        { key: "Eキー + マウス", img: require("@/assets/images/keyboard_E.png"), description: "消しゴム" },
        { key: "Ctrlキー + マウスホイール", img: require("@/assets/images/keyboard_Ctrl.png"), description: "拡大縮小" },
        { key: "Shiftキー + マウスホイール", img: require("@/assets/images/keyboard_Shift.png"), description: "左右にスクロール" },
        ],
      tabletHelpFields: [
        { key: "設問青枠内を長押し", description: "長押しした場所にテキストを出力" },
        { key: "テキストを長押し", description: "長押ししたテキストを削除" },
        { key: "問題用紙または解答用紙上でピンチイン・ピンチアウト", description: "用紙の拡大縮小<br>（手書きモードで設問青枠内では使用できません）" },
      ],
      errors: [],
      fromStudentSheetList: false,
      remainingTime: null,
      timer: null,
      isTimeOver: false,
      isRemainingTimeDisp: false,
      isTimeOverAlertDisp: false,
      isTextEnable: false,
      isDrawEnable: false,
      textColor: "#000000",
      drawColor: "#000000",
      thickness: 2,
      StudentSheetStatusEnum: StudentSheetStatusEnum,
      isScrolling: false,
      scoringToolboxLeft: 0,
      scoringToolboxTop: 0,
      PreviewImageTypeEnum: PreviewImageTypeEnum,
      previewImageType: PreviewImageTypeEnum.None,
      isDispToggre: false,
      isColorEnable: false,
    });

    /************************************************************
     * 採点結果PDF表示
     ************************************************************/

    const downloadResultPdf = async () => {
      context.root.$store.dispatch("showOverlay");
      
      await http.get(`/api/digital_paper/student_sheet_list/download_result_pdf/${state.before_student_sheet_id}`, {responseType: 'arraybuffer'}).then(response => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.target = "_blank"
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
     * メインエリアの高さを画面サイズに合わせてリサイズ
     * 初期表示・ウィンドウリサイズ時に発動
     ************************************************************/

    const adjustHeight = () => {
      const windowHeight = window.innerHeight;
      const windowWidth = window.innerWidth;
      const mainArea = document.getElementById("main-area");
      
      if(mainArea != null){
        state.mainAreaHeight = windowHeight - mainArea.offsetTop;
        state.mainAreaWidth = windowWidth;
        mainArea.style.width = state.mainAreaWidth + "px";
        mainArea.style.height = windowHeight - mainArea.offsetTop + "px";
        state.modeAreaTop = (mainArea.offsetTop + 56);
        state.modeAreaLeft = state.mainAreaWidth - state.modeAreaWidth - 20;
        state.scoringToolboxTop = (mainArea.offsetTop + 56);
        state.scoringToolboxLeft = state.mainAreaWidth - state.modeAreaWidth - 20;
      }
    };

    /************************************************************
     * 問題用紙・解答用紙を画面内に収まるようにリサイズ
     ************************************************************/

    const adjustSheet = () => {
      const answerArea = document.getElementById(`answer-page-root-${state.direction}`);
      const mainArea = document.getElementById("main-area");

      const areaW = answerArea.clientWidth - 16;
      const areaH = mainArea.clientHeight - 80;

      if(answerArea && mainArea){
        let scaleW = areaW / state.pageItems[state.selectedAnswerPageIdx].base_width;
        let scaleH = areaH / state.pageItems[state.selectedAnswerPageIdx].base_height;
        let scale = scaleW > scaleH ? scaleH * 100 : scaleW * 100;

        verticalAnswerImageAreaRef.value.inputScale = scale;
        horizonAnswerImageAreaRef.value.inputScale = scale;

        if(verticalCorrectImageAreaRef.value){
          verticalCorrectImageAreaRef.value.inputScale = scale;
        }

        if(horizonCorrectImageAreaRef.value){
          horizonCorrectImageAreaRef.value.inputScale = scale;
        }

        if(verticalQuestionImageAreaRef.value){
          scaleW = areaW / state.sheet.questionImageWidth;
          scaleH = areaH / state.sheet.questionImageHeight;
          scale = scaleW > scaleH ? scaleH * 100 : scaleW * 100;

          verticalQuestionImageAreaRef.value.inputScale = scale;
          horizonQuestionImageAreaRef.value.inputScale = scale;
        }
      }
    }

    /************************************************************
     * 横向きモードのスプリッターリサイズ
     ************************************************************/

    const horizonHeightPaneResizing = (e: ResizingEventArgs) => {
      console.log("resizing");
      state.horizonTopHeightPer = e.paneSize[0] / state.mainAreaHeight;
      state.horizonBottomHeightPer = e.paneSize[1] / state.mainAreaHeight;
    }

    /************************************************************
     * 縦向きモードのスプリッターリサイズ
     ************************************************************/

    const verticalWidthPaneResizing = (e: ResizingEventArgs) => {
      state.verticalLeftWidthPer = e.paneSize[0] / state.mainAreaWidth;
      state.verticalRightWidthPer = e.paneSize[1] / state.mainAreaWidth;
    }

    /************************************************************
     * 横向きモードの上部エリアのheight
     ************************************************************/

    const horizonModeTopHeight = computed((): any => {
      return state.mainAreaHeight * state.horizonTopHeightPer;
    });

    /************************************************************
     * 横向きモードの下部エリアのheight
     ************************************************************/

    const horizonModeBottomHeight = computed((): any => {
      return state.mainAreaHeight * state.horizonBottomHeightPer;
    });

    /************************************************************
     * 画面レイアウト縦横モード切り替え
     ************************************************************/

    const changeDirection = (direction: number) => {
      if(state.direction != direction){
        state.direction = direction;
        state.selectedAnswerText = null;

        context.root.$nextTick(() => {
          if(state.direction == DirectionEnum.Horizon){
            horizonAnswerImageAreaRef.value.renderCanvas();
          }else{
            verticalAnswerImageAreaRef.value.renderCanvas();
          }
        });
      }
    }

    /******************************
     * 解答用紙ページ切り替え時のemit
     ******************************/

    const answerSheetPageChanged = (idx: number) => {
      state.selectedAnswerPageIdx = idx;
      state.selectedAnswerText = null;
      state.selectedFieldIdx = null;
    }

    /******************************
     * 問題用紙ページ切り替え時のemit
     ******************************/

    const questionSheetPageChanged = (idx: number) => {
      state.selectedQuestionPageIdx = idx;
    }

    /******************************
     * 模範解答｀ページ切り替え時のemit
     ******************************/

    const correctImagePageChanged = (idx: number) => {
      state.selectedCorrectPageIdx = idx;
    }

    /******************************
     * 問題用紙・模範解答表示切り替え
     ******************************/

    const changeImageType = (imageType: number) => {
      state.previewImageType = imageType;
    }

    /******************************
     * 設問アイコンクリック時のemit
     ******************************/

    const changeSelectedSheetField = async (selectedFieldIdx: number) => {
      state.selectedFieldIdx = selectedFieldIdx;
      state.selectedAnswerText = null;

      if(state.status == StudentSheetStatusEnum.Answering){
        if(selectedSheetField.value){
          const baseElemId = `parent-${state.direction}-${selectedSheetField.value.id}`;
          const toolboxId = "kaitou-toolbox";
          autoMoveToolbox(baseElemId, toolboxId, "modeAreaLeft", "modeAreaTop");
        }
      }else if(state.status == StudentSheetStatusEnum.SelfScoring){
        if(selectedSheetField.value){
          const baseElemId = `scoring-parent-${state.direction}-${selectedSheetField.value.id}`;
          const toolboxId = "scoring-toolbox";
          autoMoveToolbox(baseElemId, toolboxId, "scoringToolboxLeft", "scoringToolboxTop");
        }
      }
    }

    /************************************************************
     * 選択中のテキスト要素のID
     ************************************************************/

    const selectedAnswerTextElemId = computed((): any => {
      if(!state.selectedAnswerText || !selectedSheetField.value){
        return null;
      }else{
        return `text-image-${state.direction}-${selectedSheetField.value.id}-${state.selectedAnswerText.idx}`;
      }
    });

    /************************************************************
     * 選択中の設問を返却
     ************************************************************/

    const selectedSheetField = computed((): SheetField => {
      if(state.selectedAnswerPageIdx != null && state.selectedFieldIdx != null){
        return state.pageItems[state.selectedAnswerPageIdx].sheet_fields[state.selectedFieldIdx];
      }else{
        return null;
      }
    });

    /************************************************************
     * 自己採点ツールボックスの表示判定
     ************************************************************/

    const isScoringToolBoxVisible = computed((): boolean => {
      return state.status == StudentSheetStatusEnum.SelfScoring && selectedSheetField.value != null && !state.isScrolling;
    });

    /************************************************************
     * 自己採点
     ************************************************************/

    const changeCorrectState = async (correct_state: number) => {
      selectedSheetField.value.correct_state = correct_state
      
      if(state.direction == DirectionEnum.Horizon){
        horizonAnswerImageAreaRef.value.$forceUpdate();
      }else{
        verticalAnswerImageAreaRef.value.$forceUpdate();
      }

      let isFieldChanged = false;

      const idx = state.pageItems[state.selectedAnswerPageIdx].scoreing_target_sheet_fields.indexOf(selectedSheetField.value);
      if(state.pageItems[state.selectedAnswerPageIdx].scoreing_target_sheet_fields.length > idx + 1){
        // 同ページの次の設問へ
        state.selectedFieldIdx += 1;
        isFieldChanged = true;
      }else if(state.pageItems.length > state.selectedAnswerPageIdx + 1){
        // 次のページの最初の設問へ
        state.selectedAnswerPageIdx += 1;
        state.selectedFieldIdx = state.pageItems[state.selectedAnswerPageIdx].scoreing_target_sheet_fields[0].idx;
        isFieldChanged = true;
      }

      // 次の設問位置へスクロールしてツールボックスを移動
      if(isFieldChanged){

        context.root.$nextTick(async () => {
          // マークの位置へスクロール
          const rectElement = document.getElementById(`scoring-parent-${state.direction}-${selectedSheetField.value.id}`);
          const imageArea = document.getElementById(`answer-page-root-${state.direction}`);

          const imageAreaWidth = imageArea.offsetWidth;
          const imageAreaHeight = imageArea.offsetHeight;
          const imageAreaTop = imageArea.scrollTop;
          const imageAreaBottom = imageAreaTop + imageAreaHeight;
          const imageAreaLeft = imageArea.scrollLeft;
          const imageAreaRight = imageArea.scrollLeft + imageAreaWidth;
          const rectTop = rectElement.offsetTop;
          const rectBottom = rectElement.offsetTop + rectElement.offsetHeight;
          const rectLeft = rectElement.offsetLeft;
          const rectRight = rectElement.offsetLeft + rectElement.offsetWidth;

          let fromTop = imageAreaTop;
          let toTop = imageAreaTop;
          let fromLeft = imageAreaLeft;
          let toLeft = imageAreaLeft;

          if(imageAreaTop > rectTop || imageAreaBottom < rectBottom){
            toTop = rectTop - (imageAreaHeight / 3);
          }

          if(imageAreaLeft > rectLeft || imageAreaRight < rectRight){
            toLeft = rectLeft - (imageAreaWidth / 3);
          }

          if(fromTop != toTop || fromLeft != toLeft){
            state.isScrolling = true;
            await Common.smoothScroll(fromTop, toTop, fromLeft, toLeft, imageArea);
            state.isScrolling = false;
          }

          // スクロール後の座標をもとにツールボックスを移動
          const baseElemId = `scoring-parent-${state.direction}-${selectedSheetField.value.id}`;
          const toolboxId = "scoring-toolbox";
          autoMoveToolbox(baseElemId, toolboxId, "scoringToolboxLeft", "scoringToolboxTop");
        });
      }
    }

    const scoringToolboxPointerDown = (e: PointerEvent) => {
      (e.target as HTMLElement).setPointerCapture(e.pointerId);
      state.pointerOffsetX = e.offsetX + 12;
      state.pointerOffsetY = e.offsetY + 14;
      state.isDragging = true;
    }

    const scoringToolboxPointerMove = (e: PointerEvent) => {
      if(state.isDragging){
        e.preventDefault();
        state.scoringToolboxLeft = e.clientX - state.pointerOffsetX;
        state.scoringToolboxTop = e.clientY - state.pointerOffsetY;
      }
    }

    const scoringToolboxPointerUp = (e: PointerEvent) => {
      (e.target as HTMLElement).releasePointerCapture(e.pointerId);
      state.isDragging = false;
    }

    const scoringToolboxTouchMove = (e: TouchEvent) => {
      if(state.isDragging){
        e.preventDefault();
      }
    }

    const autoMoveToolbox = (baseElemId: string, toolboxId: string, leftPosName: string, topPosName: string) => {
      context.root.$nextTick(() => {
        const baseElem = document.getElementById(baseElemId);
        const toolbox = document.getElementById(toolboxId);

        if(baseElem && toolbox){
          const clientRect = baseElem.getBoundingClientRect();
          // @ts-ignore
          state[leftPosName] = clientRect.left;
          // @ts-ignore
          state[topPosName] = clientRect.top - toolbox.clientHeight - 10;
        }
      });
    }

    /************************************************************
     * 採点モード切り替え AnserImageArea.vueからemitされる
     ************************************************************/
    
    const changeKaitouMode = (kaitouMode: number) => {
      
      const current = document.activeElement;
      if(current != null){
        (current as HTMLElement).blur();
      }
      
      state.selectedAnswerText = null;
      if(state.kaitouMode == kaitouMode){
        state.kaitouMode = state.KaitouModeEnum.None;
      }else{
        state.kaitouMode = kaitouMode;
      }
    }

    /************************************************************
     * 選択中のテキストスタンプ切り替え AnserImageArea.vueから呼ばれる
     ************************************************************/

    const changeSelectedAnswerText = (answerText: AnswerText) => {
      state.selectedAnswerText = answerText;
      if(state.selectedAnswerText){
        state.fontSize = answerText.font_size;
        state.lineHeight = answerText.line_height;
        state.textColor = answerText.color;
      }
    }

    /************************************************************
     * テキストスタンプ追加 AnserImageArea.vueから呼ばれる
     ************************************************************/

    const addAnswerText = (answerText: AnswerText) => {
      selectedSheetField.value.answer_texts.push(answerText);
      state.selectedAnswerText = answerText;
      state.textColor = answerText.color;
    }

    /************************************************************
     * テキストスタンプ削除 AnserImageArea.vueから呼ばれる
     ************************************************************/

    const deleteAnswerText = (answerText: AnswerText) => {
      const idx = selectedSheetField.value.answer_texts.indexOf(answerText);
      selectedSheetField.value.answer_texts.splice(idx, 1);
      state.selectedAnswerText = null;
    }
    
    const modeAreaHeaderPointerDown = (e: PointerEvent) => {
      (e.target as HTMLElement).setPointerCapture(e.pointerId);
      state.pointerOffsetX = e.offsetX + 4;
      state.pointerOffsetY = e.offsetY + 10;
      state.isDragging = true;
    }

    const modeAreaHeaderPointerMove = (e: PointerEvent) => {
      if(state.isDragging){
        e.preventDefault();
        state.modeAreaLeft = e.clientX - state.pointerOffsetX;
        state.modeAreaTop = e.clientY - state.pointerOffsetY;
      }
    }

    const modeAreaHeaderPointerUp = (e: PointerEvent) => {
      (e.target as HTMLElement).releasePointerCapture(e.pointerId);
      state.isDragging = false;
    }

    const modeAreaTouchMove = (e: TouchEvent) => {
      if(state.isDragging){
        e.preventDefault();
      }
    }

    /************************************************************
     * 出力済みテキストスタンプ文言編集後イベント
     ************************************************************/

    const changeAnswerText = () => {
      const size = Common.getTextSize(state.selectedAnswerText.text, state.selectedAnswerText.font_size, state.selectedAnswerText.line_height);
      state.selectedAnswerText.width = size.width;
      state.selectedAnswerText.height = size.height;
      state.selectedAnswerText.base64_text = Common.createBase64Text(state.selectedAnswerText);
    }

    /************************************************************
     * 出力済みテキストスタンプのフォントサイズ・行間変更後イベント
     ************************************************************/

    const textFormatChanged = (fontSize: number, lineHeight: number, textColor: string) => {
      state.fontSize = fontSize;
      state.lineHeight = lineHeight;
      state.textColor = textColor;
      state.selectedAnswerText.font_size = state.fontSize;
      state.selectedAnswerText.line_height = state.lineHeight;
      state.selectedAnswerText.color = state.textColor;
      const size = Common.getTextSize(state.selectedAnswerText.text, state.fontSize, state.lineHeight);
      state.selectedAnswerText.width = size.width;
      state.selectedAnswerText.height = size.height;
      state.selectedAnswerText.base64_text = Common.createBase64Text(state.selectedAnswerText);
    }

    /************************************************************
     * キー押下
     ************************************************************/

    const keyDown = (e:KeyboardEvent) => {
      
      // テキスト不可の場合のTショートカットは無効
      if(!state.isTextEnable && e.key == "t"){
        return;
      }

      // 手書き不可の場合のD/Eショートカットは無効
      if(!state.isDrawEnable && (e.key == "d" || e.key == "e")){
        return;
      }
      
      state.keyCode = e.key;
    }

    /************************************************************
     * キー入力による採点
     ************************************************************/

    const keyUp = (e: KeyboardEvent) => {

      state.keyCode = "";

      // API通信中は処理しない
      if(!state.isShortcutKeyEnable){
        return;
      }

      // メモのtextareaがフォーカスされている場合は処理しない
      if(document.activeElement.nodeName.toLowerCase() == "textarea"){
        return;
      }

      if(e.key == "Backspace" && state.selectedAnswerText != null){
        const idx = state.pageItems[state.selectedAnswerPageIdx].sheet_fields[state.selectedFieldIdx].answer_texts.indexOf(state.selectedAnswerText);
        state.pageItems[state.selectedAnswerPageIdx].sheet_fields[state.selectedFieldIdx].answer_texts.splice(idx, 1);
        state.selectedAnswerText = null;
      }
    }

    /************************************************************
     * ショートカットキー＋マウスダウンによる解答モード変更
     ************************************************************/

    const changeKaitouModeFromChild = (kaitouMode: number) => {
      state.kaitouMode = kaitouMode;
    }

    /************************************************************
     * ピンチインアウトによる画面の拡大縮小禁止処理
     ************************************************************/

    const rootTouchmove = (e: TouchEvent) => {
      if(e.touches.length > 1){
        e.preventDefault();
      }
    }

    /************************************************************
     * 残り時間・画面表示用文字列
     ************************************************************/

    const remainingTimeText = computed((): string => {
      // ミリ秒からdurationオブジェクトを生成
      const duration = moment.duration(state.remainingTime);
      
      // 日・時・分・秒を取得
      const days = Math.floor(duration.asDays());
      const hours   = duration.hours();
      const minutes = duration.minutes();
      const seconds = duration.seconds();

      // カウントダウンの結果を変数に代入
      if(days > 0){
        return '残り時間：' + days + '日' +  hours + '時間' + minutes + '分' + seconds + '秒';
      }else if(hours > 0){
        return '残り時間：' +  hours + '時間' + minutes + '分' + seconds + '秒';
      }else if(minutes > 0){
        return '残り時間：' +  minutes + '分' + seconds + '秒';
      }else{
        return '残り時間：' +  seconds + '秒';
      }
    });

    /************************************************************
     * 残り時間・画面表示用文字列
     ************************************************************/

    const timeOverAlertText = computed(() => {
      return `${Common.formatDate(state.sheet.test_end_datetime_at, "k時m分に試験が終了します")}`;
    });

    /************************************************************
     * 保存
     ************************************************************/

    const save = async () => {

      context.root.$store.dispatch("showOverlay");
      state.isShortcutKeyEnable = false;

      let sheetFields = new Array<SheetField>();
      state.pageItems.forEach(x => sheetFields = sheetFields.concat(x.sheet_fields));

      // canvas・解答文字画像をZip化
      let zip = new jsZip();
      sheetFields.forEach(x => {
        if(x.is_canvas_updated){
          zip.file(`${x.id}.png`, x.base64_canvas, {base64: true});
        }
        x.answer_texts.filter(x => x.text != null && x.text.replace(/\r?\n/g, '').trim() != "" && x.width > 0 &&  x.height > 0).forEach(y => {
          zip.file(`answer_text_${y.sheet_field_id}_${y.idx}.png`, y.base64_text, {base64: true});
        });
      });

      await zip.generateAsync({type: "blob"}).then(async (blob) => {
        if(!blob){
          return;
        }

        const fd = new FormData();
        fd.append("file", blob);
        fd.append("sheet_id", state.sheet.id.toString());
        fd.append("status", state.status.toString());
        fd.append("param_sheet_fields", JSON.stringify(sheetFields.map(x => new ParamSheetField(x))));

        if(state.fromStudentSheetList){
          fd.append("student_no_character", context.root.$store.state.student_no_character);
        }else{
          fd.append("email", context.root.$store.state.digitalPaperEmail);
        }

        await http.post(`/api/digital_paper/answer_input/save`, fd).then(() => {
          Common.showToast(context.root.$bvToast, "保存処理が完了しました。");
          state.errors = [];
        })
        .catch(error=>{
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。"];
          }
        });
      });

      context.root.$store.dispatch("hideOverlay");
      state.isShortcutKeyEnable = true;
    }

    /************************************************************
     * 自己採点保存
     ************************************************************/

    const saveCorrectState = async () => {
      
      let sheetFields = new Array<SheetField>();
      state.pageItems.forEach(x => sheetFields = sheetFields.concat(x.sheet_fields));

      const param: any = {};
      param["sheet_id"] = state.sheet.id;
      param["status"] = state.status;
      param["param_sheet_fields"] = sheetFields.map(x => new ParamSheetField(x));

      if(state.fromStudentSheetList){
        param["student_no_character"] = context.root.$store.state.student_no_character;
      }else{
        param["email"] = context.root.$store.state.digitalPaperEmail;
      }

      await http.post(`/api/digital_paper/answer_input/save_correct_state`, param).then(() => {
        Common.showToast(context.root.$bvToast, "保存処理が完了しました。");
        state.errors = [];
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
    }

    /************************************************************
     * 解答登録
     ************************************************************/

    const entryAnswer = async () => {

      if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, "解答を確定します。確定後は変更できません。よろしいですか？")){
        return;
      }

      let sheetFields = new Array<SheetField>();
      state.pageItems.forEach(x => sheetFields = sheetFields.concat(x.sheet_fields));

      if(sheetFields.filter(x => !x.isKaitouCompleted).length > 0){
        if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, "未解答の設問がありますが、よろしいですか？")){
          return;
        }
      }

      context.root.$store.dispatch("showOverlay");
      state.isShortcutKeyEnable = false;

      // canvas・解答文字画像をZip化
      let zip = new jsZip();
      sheetFields.forEach(x => {
        if(x.is_canvas_updated){
          zip.file(`${x.id}.png`, x.base64_canvas, {base64: true});
        }
        x.answer_texts.filter(x => x.text != null && x.text.replace(/\r?\n/g, '').trim() != "" && x.width > 0 &&  x.height > 0).forEach(y => {
          zip.file(`answer_text_${y.sheet_field_id}_${y.idx}.png`, y.base64_text, {base64: true});
        });
      });

      await zip.generateAsync({type: "blob"}).then(async (blob) => {
        if(!blob){
          return;
        }

        const fd = new FormData();
        fd.append("file", blob);
        fd.append("sheet_id", state.sheet.id.toString());
        fd.append("param_sheet_fields", JSON.stringify(sheetFields.map(x => new ParamSheetField(x))));

        if(state.fromStudentSheetList){
          fd.append("student_no_character", context.root.$store.state.student_no_character);
        }else{
          fd.append("email", context.root.$store.state.digitalPaperEmail);
        }

        await http.post(`/api/digital_paper/answer_input/entry_answer`, fd).then(async () => {
          await Common.customAlert(context.root.$bvModal, context.root.$store, "処理が完了しました。\n自己採点をして提出してください。");
          state.errors = [];
          state.status = StudentSheetStatusEnum.SelfScoring;
          state.previewImageType = PreviewImageTypeEnum.Correct;
          state.isDispToggre = state.sheet.question_image_completed;
        })
        .catch(error=>{
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。"];
          }
        });
      });

      context.root.$store.dispatch("hideOverlay");
      state.isShortcutKeyEnable = true;
    }

    /************************************************************
     * 提出
     ************************************************************/

    const entry = async () => {

      if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, "答案を提出します。よろしいですか？")){
        return;
      }

      let sheetFields = new Array<SheetField>();
      state.pageItems.forEach(x => sheetFields = sheetFields.concat(x.sheet_fields));

      if(state.sheet.is_self_scoring_enable){
        if(sheetFields.filter(x => x.kind == 0 && x.correct_state == null).length > 0){
          if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, "自己採点未完了の設問がありますが、提出してよろしいですか？")){
            return;
          }
        }
      }else{
        if(sheetFields.filter(x => !x.isKaitouCompleted).length > 0){
          if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, "未解答の設問がありますが、提出してよろしいですか？")){
            return;
          }
        }
      }

      context.root.$store.dispatch("showOverlay");
      state.isShortcutKeyEnable = false;

      // canvas・解答文字画像をZip化
      let zip = new jsZip();
      sheetFields.forEach(x => {
        if(x.is_canvas_updated){
          zip.file(`${x.id}.png`, x.base64_canvas, {base64: true});
        }
        x.answer_texts.filter(x => x.text != null && x.text.replace(/\r?\n/g, '').trim() != "" && x.width > 0 &&  x.height > 0).forEach(y => {
          zip.file(`answer_text_${y.sheet_field_id}_${y.idx}.png`, y.base64_text, {base64: true});
        });
      });

      await zip.generateAsync({type: "blob"}).then(async (blob) => {
        if(!blob){
          return;
        }

        const fd = new FormData();
        fd.append("file", blob);
        fd.append("sheet_id", state.sheet.id.toString());
        fd.append("param_sheet_fields", JSON.stringify(sheetFields.map(x => new ParamSheetField(x))));

        if(state.fromStudentSheetList){
          fd.append("student_no_character", context.root.$store.state.student_no_character);
        }else{
          fd.append("email", context.root.$store.state.digitalPaperEmail);
        }

        await http.post(`/api/digital_paper/answer_input/entry`, fd).then(async () => {
          await Common.customAlert(context.root.$bvModal, context.root.$store, "処理が完了しました。");
          state.errors = [];
          window.history.back();
        })
        .catch(error=>{
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。"];
          }
        });
      });

      context.root.$store.dispatch("hideOverlay");
      state.isShortcutKeyEnable = true;
    }

    /************************************************************
     * mounted
     ************************************************************/

    onMounted(async () => {

      context.root.$store.commit("setIsHeaderDisp", false);
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");

      if(context.root.$store.state.isKaitouViewReloaded){
        context.root.$store.commit("setIsKaitouViewReloaded", false);
      }else{
        context.root.$store.commit("setIsKaitouViewReloaded", true);
        window.location.reload();
        return;
      }

      state.fromStudentSheetList = !context.root.$route.path.includes("digital_paper_site");

      let param = `sheet_id=${context.root.$route.params.sheet_id}`;
      if(state.fromStudentSheetList){
        param += `&student_no_character=${context.root.$store.state.student_no_character}`
      }else{
        param += `&email=${context.root.$store.state.digitalPaperEmail}`
      }

      await http.get(`/api/digital_paper/answer_input?${param}`).then(response => {
        state.sheet = new Sheet(response.data.sheet);
        state.base64QuestionImages = response.data.base64_question_images;
        state.base64CorrectImages = response.data.base64_correct_images;
        state.before_student_sheet_id = response.data.before_student_sheet_id;
        state.cutMargin = response.data.cut_margin;
        state.status = response.data.status;
        for(let i = 0; i < state.sheet.page_count; i++){
          state.pageItems.push(new PageItem(i + 1, response.data.base64_answer_images[i], response.data.sheet_fields, state.sheet.width, state.sheet.height));
        }
        
        state.pageItems.forEach(pageItem => {
          pageItem.sheet_fields.forEach(sheet_field => {
            const self_scoring = response.data.self_scorings.find((x: any) => x.sheet_field_id == sheet_field.id)
            if(self_scoring){
              sheet_field.correct_state = self_scoring.correct_state;
            }
          });
        });

        state.isTextEnable = state.sheet.digital_answer_type == Common.DigialAnswerTypeEnum.Both || state.sheet.digital_answer_type == Common.DigialAnswerTypeEnum.Text;
        state.isDrawEnable = state.sheet.digital_answer_type == Common.DigialAnswerTypeEnum.Both || state.sheet.digital_answer_type == Common.DigialAnswerTypeEnum.Draw;
        const colorWidth = state.isColorEnable ? 0 : 25;

        if(state.isTextEnable && state.isDrawEnable){
          state.modeAreaWidth = 315 - colorWidth;
        }else if(state.isTextEnable){
          state.modeAreaWidth = 115;
        }else if(state.isDrawEnable){
          state.modeAreaWidth = 230 - colorWidth;
        }

        if(state.status >= StudentSheetStatusEnum.SelfScoring){
          state.previewImageType = PreviewImageTypeEnum.Correct;
          state.isDispToggre = state.sheet.question_image_completed;
        }else if(state.sheet.question_image_completed){
          state.previewImageType = PreviewImageTypeEnum.Question;
          state.isDispToggre = false;
        }
      })
      .catch(async error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          await Common.customAlert(context.root.$bvModal, context.root.$store, `試験情報の取得処理に失敗しました。レポート一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          await Common.customAlert(context.root.$bvModal, context.root.$store, `試験情報の取得処理に失敗しました。レポート一覧に戻ります。`);
        }
        window.history.back();
      });

      state.initiarizedData = true;
      // state.kaitouMode = context.root.$store.state.isMobile ? state.KaitouModeEnum.FreeLine : state.KaitouModeEnum.None;
      context.root.$nextTick(() => {
        adjustHeight();
        adjustSheet();
        if(!context.root.$store.state.is_preview_mode){
          changeSelectedSheetField(0);
          // state.kaitouMode = state.isDrawEnable ? KaitouModeEnum.FreeLine : KaitouModeEnum.Text;
        }
      });
      window.addEventListener("resize", adjustHeight);
      window.addEventListener("orientationchange", adjustHeight);
      window.addEventListener("keyup", keyUp);
      window.addEventListener("keydown", keyDown);

      // 終了日時が設定されている場合はタイマー起動
      if(state.sheet.test_end_datetime_at){
        state.timer = setInterval(async () => {

          // 現在日時取得
          var now = Date.now();

          // テスト終了日時から現在日時を減算し、残り時間を求める
          state.remainingTime = (state.sheet.test_end_datetime_at.getTime() - now);

          // 残り時間があるか判定
          if(!state.isTimeOver && state.remainingTime <= 0){
            // 解答操作をOFFにして提出操作のみ可能にする
            state.isTimeOver = true;
            state.isRemainingTimeDisp = false;
            state.isTimeOverAlertDisp = false;
            state.selectedFieldIdx = null;
            state.selectedAnswerText = null;

            // タイマー停止
            clearInterval(state.timer);

            if(state.sheet.is_self_scoring_enable){
              state.status = StudentSheetStatusEnum.SelfScoring;
              state.previewImageType = PreviewImageTypeEnum.Correct;
              state.isDispToggre = state.sheet.question_image_completed;
              await Common.customAlert(context.root.$bvModal, context.root.$store, `試験が終了しました。自己採点をして提出してください。`);
            }else{
              await Common.customAlert(context.root.$bvModal, context.root.$store, `試験が終了しました。提出ボタンを押して提出してください。`);
            }
          }else if(!state.isRemainingTimeDisp && state.remainingTime < 1 * 60 * 1000){
            // 残り1分でタイマー表示
            state.isRemainingTimeDisp = true;
          }else if(!state.isTimeOverAlertDisp && state.remainingTime < 5 * 60 * 1000){
            // 残り5分で終了間近のお知らせ表示
            state.isTimeOverAlertDisp = true;
          }
        }, 200);
      }
      
      context.root.$store.dispatch("hideOverlay");
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      window.removeEventListener("resize", adjustHeight);
      window.removeEventListener("orientationchange", adjustHeight);
      window.removeEventListener("keyup", keyUp);
      window.removeEventListener("keydown", keyDown);
      context.root.$store.commit("setIsHeaderDisp", true);
      if(state.timer){
        clearInterval(state.timer);
      }
    });

    return {
      ...toRefs(state),
      horizonAnswerImageAreaRef,
      verticalAnswerImageAreaRef,
      horizonQuestionImageAreaRef,
      horizonCorrectImageAreaRef,
      verticalQuestionImageAreaRef,
      verticalCorrectImageAreaRef,
      horizonHeightPaneResizing,
      verticalWidthPaneResizing,
      horizonModeTopHeight,
      horizonModeBottomHeight,
      changeDirection,
      answerSheetPageChanged,
      questionSheetPageChanged,
      correctImagePageChanged,
      changeSelectedSheetField,
      selectedSheetField,
      save,
      saveCorrectState,
      entry,
      entryAnswer,
      changeKaitouMode,
      changeSelectedAnswerText,
      addAnswerText,
      deleteAnswerText,
      changeAnswerText,
      textFormatChanged,
      modeAreaHeaderPointerDown,
      modeAreaHeaderPointerMove,
      modeAreaHeaderPointerUp,
      modeAreaTouchMove,
      downloadResultPdf,
      keyDown,
      keyUp,
      changeKaitouModeFromChild,
      rootTouchmove,
      remainingTimeText,
      timeOverAlertText,
      selectedAnswerTextElemId,
      isScoringToolBoxVisible,
      changeCorrectState,
      scoringToolboxPointerDown,
      scoringToolboxPointerMove,
      scoringToolboxPointerUp,
      scoringToolboxTouchMove,
      changeImageType,
     };
  }
})
